import { isNumber } from './get-type.utils';

export const sortArray = <T>(
    array: T[],
    propName?: keyof T,
    isAscending = true
): T[] => {
    const getPropAsString = (item: any): string =>
        ((propName ? item[propName] : item) || '').toString();
    const result = [...array].sort((a, b) => {
        const firstVal = getPropAsString(a);
        const secondVal = getPropAsString(a);
        if (isNumber(+firstVal) && isNumber(+secondVal)) {
            return +firstVal - +secondVal;
        }
        return getPropAsString(a).localeCompare(getPropAsString(b));
    });

    if (!isAscending) result.reverse();
    return result;
};

export const filterArrayOfObjectsBy = <T>(
    arr: T[],
    searchString: string,
    keys: (keyof T)[]
): T[] =>
    arr.filter((item) =>
        keys.some((k) =>
            String(item[k] ?? '')
                .toLowerCase()
                .includes(searchString.toLowerCase())
        )
    );

export const sortArrayByPropertyAlphabetically = (arr: any[], sortBy: string) =>
    arr
        .filter((c) => c[sortBy])
        .sort((a, b) =>
            a[sortBy].toLowerCase().localeCompare(b[sortBy].toLowerCase())
        );
